import type { LinkedAccount } from '../cards.types';

export const linkedAccountsFixture: LinkedAccount[] = [
  {
    id: 'acc-eur-main',
    name: 'EUR Main',
    currency: 'EUR',
    iban: 'GB29 NWBK 6016 1331 9268 19',
    balance: 4321.5,
  },
  {
    id: 'acc-eur-taxes',
    name: 'EUR Taxes',
    currency: 'EUR',
    iban: 'GB29 NWBK 6016 1331 4525 72',
    balance: 12995,
  },
  {
    id: 'acc-usd-main',
    name: 'USD Main',
    currency: 'USD',
    iban: 'GB29 NWBK 6016 1331 0023 44',
    balance: 8810.2,
  },
  {
    id: 'acc-gbp-main',
    name: 'GBP Main',
    currency: 'GBP',
    iban: 'GB82 WEST 1234 5698 7654 32',
    balance: 15200,
  },
  {
    id: 'acc-chf-main',
    name: 'CHF Main',
    currency: 'CHF',
    iban: 'CH93 0076 2011 6238 5295 7',
    balance: 2400,
  },
];
